import { watchOnce } from '@vueuse/core';
import { reactive } from 'vue';

import { isFeatureToggleActive } from '../customFeatureToggles';

export type StatsigExperimentName = 'example_experiment';

interface StatsigExperimentState {
  value: boolean;
  isLoaded: boolean;
}

type StatsigExperiments = Record<StatsigExperimentName, StatsigExperimentState>;

const statsigExperiments = reactive<StatsigExperiments>({
  example_experiment: { value: false, isLoaded: false }, // NOTE: can be removed when other experiments available
});

export function assignExperimentValue(
  experimentName: StatsigExperimentName,
  value: boolean
): void {
  statsigExperiments[experimentName].value = value;
  statsigExperiments[experimentName].isLoaded = true;
}

export async function isExperimentAsync(
  experimentName: StatsigExperimentName
): Promise<boolean> {
  return new Promise((resolve) => {
    if (isFeatureToggleActive(experimentName)) {
      resolve(true);
    } else if (isFeatureToggleActive(`!${experimentName}`)) {
      resolve(false);
    } else if (statsigExperiments[experimentName].isLoaded) {
      resolve(statsigExperiments[experimentName].value);
    } else {
      watchOnce(
        () => statsigExperiments[experimentName].isLoaded,
        async () => resolve(statsigExperiments[experimentName].value)
      );
    }
  });
}
